import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

//Ganti csv ke excel extension
const downloadExcel = (object, filename) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const ws = XLSX.utils.json_to_sheet(object);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename + fileExtension);
};

export default downloadExcel;



// WEBPACK FOOTER //
// src/services/downloadExcel.js